import dayjs from "dayjs";
require("dayjs/locale/id");

const inboundPrint = (data) => {
  const totalEstimateWeight = data?.transaction_details?.reduce(
    (acc, item) => acc + item?.estimate_weight || 0,
    0,
  );
  const totalPlastik = data?.transaction_details?.reduce(
    (acc, item) => acc + item?.estimate_qty || 0,
    0,
  );

  const productsTotalWeightByProductId = data?.transaction_details?.reduce(
    (acc, item) => {
      const productName = item?.product?.name;
      const productId = item?.product?.id;
      const estimateWeight = Math.round(+item?.estimate_weight) || 0;
      if (!acc[productId]) {
        acc[productId] = {
          name: productName,
          weight: estimateWeight,
        };
      } else {
        acc[productId].weight += estimateWeight;
      }
      return acc;
    },
    {},
  );

  const productsArray = Object.values(productsTotalWeightByProductId);

  return `
    <!DOCTYPE html>
<html lang="en">
  <head>
    <meta charset="UTF-8" />
    <meta name="viewport" content="width=device-width, initial-scale=1.0" />
    <title>${data.document_number ?? "Dokumen Inbound"}</title>
    <link
  rel="stylesheet"
  href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.5.0/css/all.min.css"
/>
    <style>
      @media print {
        @page {
          size: 9.5in 11in;
          margin: 10mm;
        }

        body {
          width: 9.5in;
          height: 11in;
        }
      }

      body {
        font-family: Arial, sans-serif;
        font-size: 10px;
        margin: 0;
        padding: 0;
        position: relative;
      }

        body::before {
        content: "";
        position: fixed;
        top: 0;
        left: 0;
        width: 100vw;
        height: 100vh;
        background-image: url('/logo.png');
        background-repeat: no-repeat;
        background-position: center;
        background-size: 80%;
        opacity: 0.08;
        z-index: 0;
        transform: rotate(-30deg);
        pointer-events: none;
        }

      table {
      width: 100%;
      border-collapse: collapse;
      /* margin-top: 5px; */
      margin: 0 5rem 0 5rem;
      }

    table, th, td {
      border: 1px solid black;
      text-align: center;
      padding: 3px;
    }

    h2 {
        margin: 5px;
    }
    </style>

  </head>
  <body style="display:flex; flex-direction:column; min-height:100vh;">
    <div
      style="
        position: relative;
        display: flex;
        flex-direction: column;
        align-items: center;
        text-align: center;
      "
    >
      <h2>WMS ELBE</h2>
      <h2>DOKUMEN INBOUND</h2>
      <h2>NOMOR: ${data.document_number ?? "-"}</h2>
    </div>

    <div
      style="
        display: flex;
        justify-content: space-between;
        margin: 0 5rem 0 5rem;
      "
    >
      <div>
        <p>Tanggal Request: <span>${
          data?.request_at
            ? dayjs(data?.request_at).locale("id").format("DD MMMM YYYY")
            : " "
        }</span></p>
        <p>Pemilik Barang: <span>${data?.client?.name}</span></p>
      </div>
      <div>
        <p>Tanggal Inbound: <span>${
          data?.schedule_at
            ? dayjs(data?.schedule_at).locale("id").format("DD MMMM YYYY")
            : " "
        }</span></p>
        <p>Material Handling - Inbound: <span>${
          data?.material_handling_fee_type ?? "-"
        }</span></p>
                <p>Tally: <span>${
                  data?.transaction_details[0]?.transaction_detail_pallets[0]
                    ?.tally?.name ?? "-"
                }</span></p>
      </div>
    </div>


    <div style="display: flex; justify-content: center; margin-top: 20px">
        <table>
            <thead>
                <tr>
                    <th>Pallet</th>
                    <th>Jenis Produk</th>
                    <th>Berat</th>
                    <th>Jumlah Pack</th>
                    <th>Spesifikasi</th>
                    <th>Lokasi</th>
                </tr>
            </thead>
            <tbody>
            ${data?.transaction_details
              ?.map(
                (item, index) => `                
                <tr key="${index}">
                    <td>${
                      item?.transaction_detail_pallets[0]?.pallet?.name ?? "-"
                    }</td>
                    <td>${item?.product?.name ?? "-"}</td>
                    <td>${Math.round(item?.estimate_weight)} kg</td>
                    <td>${item?.estimate_qty}</td>
                    <td>${item?.estimate_specification ?? "-"}</td>
                    <td>${
                      item?.transaction_detail_pallets[0]?.area?.name ?? "-"
                    }</td>
                </tr>
                `,
              )
              .join("")}
            </tbody>
            <tfoot>
                <tr>
                    <td colspan="2">Total</td>
                    <td>${Math.round(totalEstimateWeight)} kg</td>
                    <td>${totalPlastik}</td>
                    <td></td>
                </tr>
            </tfoot>
        </table>
    </div>

    <div
      style="
        display: grid;
        grid-template-columns: minmax(120px, 150px) auto;
        gap: 4px 8px;
        margin: 1rem 5rem 0 5rem;
      "
    >
      ${productsArray
        ?.map(
          (product) => `
          <div>Total berat ${product.name}</div>
          <div>: ${Math.round(product.weight)} Kg</div>
        `,
        )
        .join("")}
    </div>

    <div style="margin-top:auto; padding-top: 100px">
      <div style="display: flex; justify-content: space-between; margin: 0 5rem;">
        <div style="text-align: center;">
          <p>Pengguna Jasa</p>
          <br><br><br><br><br>
          <strong>${data?.client?.name}</strong>
        </div>

        <div style="text-align: center;">
          <p>Penyedia jasa</p>
          <br><br><br><br><br>
          <strong>ELBE Group</strong>
        </div>
      </div>

      <div style="text-align: center; margin-top: 1rem; page-break-after: always;">
        <h2>
          Customer Service:
          <i class="fab fa-whatsapp"></i> 081225151232
          <i class="fas fa-globe"></i> https://www.lautanberkatfood.com/
          <i class="fas fa-envelope"></i> lautanberkatfood@gmail.com
        </h2>
      </div>
    </div>

  </body>
</html>
`;
};

export default inboundPrint;
